import { render, staticRenderFns } from "./UploadLandedCostsModal.vue?vue&type=template&id=35f113c5&scoped=true&"
import script from "./UploadLandedCostsModal.vue?vue&type=script&lang=js&"
export * from "./UploadLandedCostsModal.vue?vue&type=script&lang=js&"
import style0 from "./UploadLandedCostsModal.vue?vue&type=style&index=0&id=35f113c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f113c5",
  null
  
)

export default component.exports